import { AlertCircle, RefreshCw } from 'lucide-react';

export function ReadError({ onRetry, loading, hasLoaded }) {
  return <div className="rounded-2xl bg-zinc-50 p-4 dark:bg-zinc-900">
    <div role="alert" className="flex items-start gap-3">
      <AlertCircle aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-red-600 dark:text-red-400" />
      <div><p className="text-sm font-semibold text-foreground">Ophalen is niet gelukt</p>
        <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-400">{hasLoaded ? 'Je ziet de laatst geladen gegevens.' : 'Probeer het opnieuw om je gegevens te bekijken.'}</p>
      </div>
    </div>
    <button type="button" onClick={onRetry} disabled={loading} className="mt-2 inline-flex min-h-11 items-center gap-2 rounded-xl px-2 text-sm font-semibold text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50"><RefreshCw aria-hidden="true" className="h-4 w-4" />Opnieuw proberen</button>
  </div>;
}

export function ReadRefreshing() {
  return <p role="status" className="flex items-center gap-2 px-1 text-xs text-zinc-500 dark:text-zinc-400"><RefreshCw aria-hidden="true" className="h-3.5 w-3.5 animate-spin motion-reduce:animate-none" />Gegevens bijwerken…</p>;
}

export function ReadEmpty({ title, description, action, onAction }) {
  return <div className="rounded-2xl bg-zinc-50 p-5 dark:bg-zinc-900">
    <p className="text-base font-semibold text-foreground">{title}</p>
    <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-400">{description}</p>
    {action && <button type="button" onClick={onAction} className="mt-2 min-h-11 rounded-xl px-2 text-sm font-semibold text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary">{action}</button>}
  </div>;
}

export function ReadSkeleton({ label, count = 2 }) {
  return <div role="status" aria-label={label} className="space-y-4">
    <span className="sr-only">{label}</span>
    {Array.from({ length: count }, (_, index) => <div key={index} aria-hidden="true" className="space-y-4 rounded-2xl bg-zinc-50 p-5 motion-safe:animate-pulse dark:bg-zinc-900">
      <div className="flex items-center justify-between gap-4"><div className="h-4 w-2/5 rounded bg-zinc-200 dark:bg-zinc-800" /><div className="h-5 w-1/5 rounded bg-zinc-200 dark:bg-zinc-800" /></div>
      <div className="h-3 w-3/5 rounded bg-zinc-200 dark:bg-zinc-800" /><div className="h-3 w-1/3 rounded bg-zinc-200 dark:bg-zinc-800" />
    </div>)}
  </div>;
}
